import React from 'react';
import { observer } from 'mobx-react';
import { RevenueCalculatorStore } from '../../revenue-calculator/RevenueCalculator.store';
import { useLocalStore } from '../../local-store-provider/LocalStoreProvider.utils';
import { Box, Button, TextField, Typography } from '@mui/material';
import { COLORS_GREEN, COLORS_RED } from '../../../App.constants';

export const CallToAction: React.FC = observer(() => {
  const localStore = useLocalStore<RevenueCalculatorStore>();

  return (
    <Box
      position={'absolute'}
      top={0}
      left={0}
      width={'100%'}
      height={'100%'}
      bgcolor={'rgba(255,255,255,0.6)'}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Box
        bgcolor={COLORS_GREEN}
        paddingX={6}
        paddingY={2}
        width={'600px'}
        height={'125px'}
      >
        <Typography
          color={'white'}
          fontWeight={'bold'}
        >
          Work Email
        </Typography>
        <Box
          display={'flex'}
          height={'45px'}
        >
          <Box
            height={'45px'}
            bgcolor={'white'}
            flexGrow={1}
            display={'flex'}
            alignItems={'center'}
            paddingX={2}
          >
            <TextField
              variant={'standard'}
              fullWidth={true}
              InputProps={{
                disableUnderline: true,
              }}
              style={{
                borderRadius: 0,
                marginBottom: '-5px',
              }}
              size={'small'}
              inputProps={{
                style: { borderRadius: 0 },
              }}
              value={localStore.emailAddress}
              onChange={(event) => localStore.updateEmailAddress(event.target.value)}
            />
          </Box>

          <Button
            type={'submit'}
            style={{ borderRadius: 0, height: '45px' }}
            variant={'contained'}
            disabled={!localStore.isValidWorkEmail}
            onClick={localStore.submitEmail}
          >
            Submit
          </Button>
        </Box>

        {localStore.isValidEmail && !localStore.isValidWorkEmail && (
          <Box marginY={1}>
            <Typography
              fontSize={'0.75rem'}
              color={COLORS_RED}
              fontWeight={'bold'}
            >
              Professional submissions only, please use a work email.
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
});

CallToAction.displayName = 'CallToAction';
